import React from 'react';
import { Card, CardContent, Typography, Box, Chip, Divider } from '@mui/material';
import { Link } from 'react-router-dom'; // Import Link from React Router for navigation
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMap } from '@fortawesome/free-solid-svg-icons'
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useThemeContext } from '../../styles/ThemeContext';

import * as CONSTANTS from "../../constants"

const OrganizationCard = ({organization, lang}) => {

    const { darkMode,  } = useThemeContext();

    let region = '';
    CONSTANTS.COUNTRY_LIST.forEach(country => {
        if (country.code === organization.region) {
            region = country.label[lang];
            return;
        }
    });

    return (
        <Card>
            {/* Make the whole card clickable */}
            <Link to={`/${lang}/organizations/${organization.uid.toString()}/`} style={{ textDecoration: 'none'}}>
                <CardContent>
                    {/* Card content info */}
                    <Box ml={2}>
                        <Typography variant="h6" component="div" color="textPrimary" sx={{ fontWeight: 'bold' }}>
                            {organization.name}
                        </Typography>
                        <Box sx={{ m: 1 }} />
                        <Typography variant="body2" color="textSecondary">
                            <FontAwesomeIcon icon={faMap} />
                            {" "+region}
                        </Typography>
                        <Box sx={{ m: 1 }} />
                        <Box minHeight={'1.75rem'}>
                            {organization.markings.map((marking) => (
                                <Chip
                                    key={marking.toString()} 
                                    label={marking.toString()}
                                    variant="outlined"
                                    size='small'
                                    sx={{
                                        borderRadius: '0.5rem',
                                        // backgroundColor: '#f0f0f0',
                                        borderColor: '#ccc',
                                        marginRight: '0.25rem',
                                        marginTop: '0.25rem',
                                    }}
                                />
                            ))}
                        </Box>
                        <Box sx={{ m: 1 }} />
                        <Divider />
                        <Box sx={{ m: 1 }} />
                        <Box display="flex" alignItems="center">
                            <VisibilityIcon style={{ color: darkMode? 'white':  'black' }}/>
                            <Typography ml={1}  variant="body1" color="textSecondary">{organization.views}</Typography>
                        </Box>
                    </Box>
                </CardContent>
            </Link>
        </Card>
    );
};

export default OrganizationCard;